export const GET_OFFERINGS_SUCCESS = 'GET_OFFERINGS_SUCCESS';
export const SET_OFFERINGS_LOADING = 'SET_OFFERINGS_LOADING';
